import { Calculation } from 'types/domainTypes';

export const duplicateCalculationData = (calculation: Calculation, projectStandardId?: string): Calculation => {
  const calculationStandardId = calculation.standard?.id;
  const standardDuplicate = calculationStandardId === projectStandardId ? undefined : calculation.standard;

  return {
    details: {
      ...calculation?.details,
    },
    fasteners: calculation?.fasteners,
    product: calculation?.product,
    spansAndLoads: calculation?.spansAndLoads,
    standard: standardDuplicate,
    temperature: calculation?.temperature,
    zoneDetails: calculation?.zoneDetails,
  } as Calculation;
};
